<div style='height: 100px; background: #EEEEEE 0% 0% no-repeat padding-box;' class='border-4 border-bottom'>
  <div class="row">
    <div class="col-md-12">
      <h2 class="text-center pt-4">
        <span class="font-color-navy welcome-text pt-4">Review Center Health</span>
      </h2>
    </div>
  </div>
</div>
<div class="container-fluid font-color-navy container-shadow">
  <table class="table-new-design">
    <thead>
      <tr>
        <th>
          Angular application status
        </th>
        <th>
          Backend Service status
        </th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>
          <span class="healthy">Angular application is Up and running.</span>
        </td>
        <td>
          <span *ngIf="isError" class="error">{{response}}</span>
          <span *ngIf="!isError" class="healthy">{{response.database}}----{{response.ads}}</span>
        </td>
      </tr>
    </tbody>
  </table>
</div>
